import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function LogKeyListener() {
  const keyCountRef = useRef(0);
  const lastTimeRef = useRef(0);
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!e?.key) return;
      const now = Date.now();
      if (e.key.toLowerCase() === 'l') {
        if (now - lastTimeRef.current < 300) {
          keyCountRef.current += 1;
        } else {
          keyCountRef.current = 1;
        }
        lastTimeRef.current = now;
        if (keyCountRef.current === 3) {
          navigate('/logs');
          keyCountRef.current = 0;
        }
      } else {
        keyCountRef.current = 0;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);

  return null;
}

export default LogKeyListener;